import React, { useState } from 'react';
import { Share2 } from 'lucide-react';

const ShareButton = ({ title, url }) => {
  const [showShareMenu, setShowShareMenu] = useState(false);

  const shareText = "Today's wisdom from Proverbs Daily 📖✨ Check it out!";
  const shareUrl = url;

  const handleFacebookShare = () => {
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}&quote=${encodeURIComponent(shareText)}`;
    window.open(facebookUrl, '_blank', 'width=600,height=400');
  };

  const handleTwitterShare = () => {
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`;
    window.open(twitterUrl, '_blank', 'width=600,height=400');
  };

  const handleSMSShare = async () => {
    try {
      // Check if the Web Share API supports sharing via SMS
      if (navigator.share) {
        await navigator.share({
          title: title,
          text: shareText,
          url: shareUrl
        });
      } else {
        // Fallback for SMS on desktop or unsupported browsers
        const smsUrl = `sms:?body=${encodeURIComponent(`${shareText} ${shareUrl}`)}`;
        window.open(smsUrl);
      }
    } catch (error) {
      console.error('Error sharing via SMS:', error);
    }
  };

  const handleNativeShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: title,
          text: shareText,
          url: shareUrl
        });
      } else {
        setShowShareMenu(true);
      }
    } catch (error) {
      console.error('Error sharing:', error);
      setShowShareMenu(true);
    }
  };

  return (
    <div className="relative">
      <button
        onClick={handleNativeShare}
        className="fixed bottom-4 right-4 w-12 h-12 bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-lg flex items-center justify-center"
        aria-label="Share"
      >
        <Share2 className="h-6 w-6" />
      </button>

      {/* Share menu overlay */}
      {showShareMenu && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40"
            onClick={() => setShowShareMenu(false)}
          />
          
          {/* Share menu */}
          <div className="fixed bottom-20 right-4 bg-white rounded-lg shadow-xl p-4 z-50 min-w-[200px]">
            <div className="flex flex-col space-y-3">
              <button
                onClick={handleFacebookShare}
                className="flex items-center space-x-3 px-4 py-2 text-left hover:bg-gray-100 rounded-md"
              >
                <svg className="w-5 h-5 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z"/>
                </svg>
                <span>Share on Facebook</span>
              </button>

              <button
                onClick={handleTwitterShare}
                className="flex items-center space-x-3 px-4 py-2 text-left hover:bg-gray-100 rounded-md"
              >
                <svg className="w-5 h-5 text-blue-400" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.44 4.83c-.8.37-1.5.38-2.22.02.93-.56.98-.96 1.32-2.02-.88.52-1.86.9-2.9 1.1-.82-.88-2-1.43-3.3-1.43-2.5 0-4.55 2.04-4.55 4.54 0 .36.03.7.1 1.04-3.77-.2-7.12-2-9.36-4.75-.4.67-.6 1.45-.6 2.3 0 1.56.8 2.95 2 3.77-.74-.03-1.44-.23-2.05-.57v.06c0 2.2 1.56 4.03 3.64 4.44-.67.2-1.37.2-2.06.08.58 1.8 2.26 3.12 4.25 3.16C5.78 18.1 3.37 18.74 1 18.46c2 1.3 4.4 2.04 6.97 2.04 8.35 0 12.92-6.92 12.92-12.93 0-.2 0-.4-.02-.6.9-.63 1.96-1.22 2.56-2.14z"/>
                </svg>
                <span>Share on X/Twitter</span>
              </button>

              <button
                onClick={handleSMSShare}
                className="flex items-center space-x-3 px-4 py-2 text-left hover:bg-gray-100 rounded-md"
              >
                <svg className="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12z"/>
                </svg>
                <span>Share via SMS</span>
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ShareButton; 